/**
 * Boutons sticky de l'outro (position: sticky en CSS) : masque le chatbot
 * sticky tant qu'une section avec boutons sticky est à l'écran.
 * En mobile, masque aussi les boutons flottants (chatbot, cookies).
 */
export class OutroSticky {
  constructor() {
    const sections = [...document.querySelectorAll('.js-outro-sticky')]
      .map((links) => links.closest('section'))
      .filter(Boolean)

    if (!sections.length || !('IntersectionObserver' in window)) {
      return
    }

    const visible = new Set()
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)
      })

      const isActive = visible.size > 0

      document.body.classList.toggle('has-outro-sticky', isActive)
      this.toggleCookieButton(isActive)
    })

    sections.forEach((section) => observer.observe(section))
  }

  /**
   * Le bouton de rappel des cookies (consentmanager) est dans le shadow DOM
   * de #cmpwrapper : inaccessible au CSS du thème, on y injecte un style
   */
  toggleCookieButton(isActive) {
    const wrapper = document.getElementById('cmpwrapper')
    const root = wrapper && wrapper.shadowRoot

    if (!root) {
      return
    }

    if (!root.querySelector('.js-outro-sticky-style')) {
      const style = document.createElement('style')
      style.className = 'js-outro-sticky-style'
      style.textContent = `
        @media screen and (max-width: 47.9975rem) {
          :host(.has-outro-sticky) #cmpboxrecall {
            opacity: 0 !important;
            visibility: hidden !important;
            pointer-events: none !important;
          }
        }
      `
      root.appendChild(style)
    }

    wrapper.classList.toggle('has-outro-sticky', isActive)
  }
}
